import React from 'react';
import { trackAddToCart } from '../utils/metaPixel';
interface ButtonCTAProps {
  text?: string;
  className?: string;
  href?: string;
  external?: boolean;
}
export function ButtonCTA({
  text = 'QUIERO SABORES QUE ADELGAZAN AHORA',
  className = '',
  href = '#comprar',
  external = false
}: ButtonCTAProps) {
  const handleClick = () => {
    if (external) {
      trackAddToCart();
    }
  };
  return <div className="inline-flex flex-col items-center w-full sm:w-auto" data-id="element-13">
      <a href={href} onClick={handleClick} {...external ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} className={`inline-block bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-4 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:-translate-y-1 text-center w-full sm:w-auto ${className}`} data-id="element-14">
        {text}
      </a>
      <p className="mt-4 text-base sm:text-lg font-bold text-olive-green text-center" data-id="element-15">
        ✅ Más de 100 personas ya están comiendo mejor
      </p>
    </div>;
}